<template>
  <Page title="Edit Membership Program">
    <Breadcrumbs
      :crumbs="crumbs"
      root-text="Membership Programs"
      class="mb-3"
      @click="handleCrumbClick"
    />
    <MembershipProgramForm v-if="currentMembershipProgram" />
  </Page>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getPathValueAt } from "@/lib/url.js";

import Page from "@/components/Page.vue";
import MembershipProgramForm from "@/MembershipPrograms/MembershipProgramForm.vue";
import Breadcrumbs from "serviceshift-ui/components/General/Breadcrumbs.vue";
export default {
  components: {
    Page,
    MembershipProgramForm,
    Breadcrumbs
  },
  computed: {
    ...mapState(["currentMembershipProgram"]),
    crumbs() {
      if (this.currentMembershipProgram) {
        return [
          {
            id: this.currentMembershipProgram.id,
            label: this.currentMembershipProgram.name
          }
        ];
      }
      return [];
    }
  },
  mounted() {
    this.fetchProgram();
  },
  methods: {
    ...mapActions(["fetchMembershipProgram"]),
    fetchProgram() {
      const id = getPathValueAt(1);
      this.fetchMembershipProgram(id);
    },
    handleCrumbClick(crumb) {
      if (crumb.id === "root") {
        this.$router.push(this.membershipProgramIndexPath());
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
